<template>
  <box-model title="农资使用量占比">
    <template v-slot:content>
      <div v-if="selList.length" class="select-part">
        <select-box :sty="false" :list="selList" :item="selItem" @sel="selEvent"></select-box>
      </div>
      <div v-if="!show" class="con no-data-sty">暂无数据</div>
      <div v-else>
        <div id="echart" class="con"></div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import echarts from 'echarts'
  import { statisticsFarmLogs } from "@/api/index"
  export default {
    data() {
      return {
        selList: [],
        selItem: {},

        data: [],

        sumValue: 0,

        show: false
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue"),
      "select-box": () => import("../../components/common/SelectBox.vue")
    },
    mounted(){
      this.getYearFn();
    },
    methods: {
      // 年份获取
      getYearFn(){
        const curYear = new Date().getFullYear();
        this.selList = [
          {name: `${curYear}年`, value: curYear},
          {name: `${curYear - 1}年`, value: curYear-1},
          {name: `${curYear - 2}年`, value: curYear-2}
        ];
        this.selItem = this.selList[0];
        this.statisticsFarmLogsFn();
      },
      selEvent(item) {
        this.selItem = item;
        this.statisticsFarmLogsFn();
      },
      init() {
        const myChart = echarts.init(document.getElementById("echart"));
        let arrName = this.getArrayValue(this.data, "name");
        let arrValue = this.getArrayValue(this.data, "value");
        this.sumValue = eval(arrValue.join('+'));
        let objData = this.array2obj(this.data, "name");
        let optionData = this.getData(this.data);
        let colors = this.getColorArr(this.data);
        let option = {
          legend: {
            orient: 'vertical',
            show: true,
            top: "20",
            left: 'right',
            data: arrName,
            itemWidth: 12,
            temHeight: 12,
            formatter: function(name) {
              return `${name}   ${objData[name].value}${objData[name].unit || ''}`
            },
            textStyle: {
              color: "rgba(255,255,255,.45)",
              rich: {
                title: {
                  fontSize: 14,
                  color: "rgba(255,255,255,.45)"
                },
                value: {
                  fontSize: 14,
                  color: "rgba(255,255,255,.85)"
                }
              }
            },
          },
          tooltip: {
            show: true,
            trigger: "item",
            backgroundColor: 'rgba(255,255,255,.9)',
            formatter: function(item){
              let result = `
                <div style="padding: 12px;z-index:1001">
                  <div style="color: #3E3E3E;font-size: 15px;">${item.name}</div>
                  <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                  <div style="display: flex;align-items: center;">
                    <div style="width: 8px;height: 8px;background: ${item.color};border-radius: 50%;"></div>
                    <div style="color: #000E2B;font-size: 15px;margin-left: 4px;line-height: 16px;">使用量：${item.value}kg</div>  
                  </div>
                </div>
              `;
              return result;
            },
          },
          color: colors,
          grid: {
            top: '6%',
            bottom: '64%',
            left: "30%",
            containLabel: false
          },
          yAxis: [{
            type: 'category',
            inverse: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              inside: true,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              show: true
            },
            data: optionData.yAxis
          }],
          xAxis: [{
            show: false
          }],
          series: optionData.series
        };
        myChart.setOption(option);
      },
      getColorArr(array) {
        let result = [];
        array.forEach((item) => {
          result.push(item.color)
        });
        return result;
      },
      getArrayValue(array, key) {
        var key = key || "value";
        var res = [];
        if (array) {
          array.forEach(function(t) {
            res.push(t[key])
          })
        }
        return res
      },
      array2obj(array, key) {
        var resObj = {};
        for (var i = 0; i < array.length; i++) {
          resObj[array[i][key]] = array[i]
        }
        return resObj
      },
      getData() {
        var res = {
          series: [],
          yAxis: []
        };
        for (let i = 0; i < this.data.length; i++) {
          res.series.push({
            name: '数据',
            type: 'pie',
            clockWise: false,
            hoverAnimation: false,
            radius: [85 - i * 15 + '%', 75 - i * 15 + '%'],
            center: ["30%", "50%"],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false
              },
              borderWidth: 5,
            },
            data: [{
              value: this.data[i].value,
              name: this.data[i].name
            }, {
              value: this.sumValue ? this.sumValue - this.data[i].value : 100,
              name: '',
              itemStyle: {
                color: "rgba(0,0,0,0)",
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }]
		      });
          res.series.push({
            name: '',
            type: 'pie',
            silent: true,
            z: 1,
            clockWise: false,
            hoverAnimation: false,
            radius: [85 - i * 15 + '%', 75 - i * 15 + '%'],
            center: ["30%", "50%"],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false
              },
              borderWidth: 5,
            },
            data: [{
              value: 7.5,
              itemStyle: {
                color: "rgba(255,255,255,.1)",
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }, {
              value: 2.5,
              name: '',
              itemStyle: {
                color: "rgba(0,0,0,0)",
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }]
          });
          if(this.sumValue){
            res.yAxis.push((this.data[i].value / this.sumValue * 100).toFixed(2) + "%");
          } else {
            res.yAxis.push('0%');
          };
        };
        return res;
      },
      statisticsFarmLogsFn(){
        statisticsFarmLogs({
          year: this.selItem.value
        }).then((res) => {
          if(!res.data || !res.data?.length){
            this.show = false;
            return;
          };
          const result = res.data;
          const color = {
            0: '#38EAFF',
            1: '#FFFFFF',
            2: '#FFCC00'
          };
          const list = [];
          result.forEach((item, index) => {
            if(item.agriculturalName != '其他'){
              item['name'] = item.agriculturalName;
              item['value'] = item.dosage ? +item.dosage : 0;
              item['color'] = color[index];
              list.push(item);
            }
          });
          this.show = true;
          this.$nextTick(()=> {
            this.data = list;
            this.initData();
          });
        })
      },
      initData(){
        this.$nextTick(() => {
          this.init();
        });
      }
    }
  }
</script>
<style scoped lang="less">
  .select-part {
    position: absolute;
    top: -10px;
    right: 10px;
    width: 100px;
    font-size: 14px;
    font-weight: 400;
  }
  .con {
    width: 100%;
    height: 220px;
  }
</style>